import React from 'react'
import { Redirect } from 'react-router-dom'

import { skuit } from 'src/services/skuit'

export const Logout = () => {
  skuit.auth.logout()
  return <Redirect to="/auth/login" />
}
